import {useEffect, useState} from 'react';

const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

const getInitialPreference = () => !!window.matchMedia?.(REDUCED_MOTION_QUERY).matches;

/**
 * True when the OS asks for reduced motion. Subscribed rather than read once, so flipping
 * the system setting takes effect without a reload.
 */
function usePrefersReducedMotion(): boolean {
    const [prefersReducedMotion, setPrefersReducedMotion] = useState(getInitialPreference);

    useEffect(() => {
        const mediaQuery = window.matchMedia?.(REDUCED_MOTION_QUERY);
        if(!mediaQuery) {
            return;
        }
        const handleChange = (event: MediaQueryListEvent) => setPrefersReducedMotion(event.matches);
        mediaQuery.addEventListener('change', handleChange);
        return () => mediaQuery.removeEventListener('change', handleChange);
    }, []);

    return prefersReducedMotion;
}

export default usePrefersReducedMotion;
